import { BitmapImage2D } from '../image/BitmapImage2D';
import { BitmapImageCube } from '../image/BitmapImageCube';
import { ImageSampler } from '../image/ImageSampler';
import { DefaultGraphicsFactory } from '../factories/DefaultGraphicsFactory';
var ImageUtils = /** @class */ (function () {
    function ImageUtils() {
    }
    ImageUtils.getImageBuffer = function (img) {
        var canvas = this.CANVAS || (this.CANVAS = document.createElement('canvas'));
        var context = canvas.getContext('2d');
        if (img instanceof HTMLImageElement) {
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
        }
        else {
            canvas.width = img.width;
            canvas.height = img.height;
        }
        context.drawImage(img, 0, 0);
        return context.getImageData(0, 0, canvas.width, canvas.height).data;
    };
    /**
     *
     */
    ImageUtils.imageToBitmapImage2D = function (img, powerOfTwo, factory) {
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        if (factory === void 0) { factory = null; }
        if (!factory)
            factory = new DefaultGraphicsFactory();
        var width;
        var height;
        if (img instanceof HTMLImageElement) {
            width = img.naturalWidth;
            height = img.naturalHeight;
        }
        else {
            width = img.width;
            height = img.height;
        }
        var image2D = factory.createImage2D(width, height, true, null, powerOfTwo);
        image2D.addLazySymbol({
            needParse: true,
            definition: {
                width: width,
                height: height,
                isPMA: true,
                data: null
            },
            lazyParser: function () {
                this.needParse = false;
                this.definition.data = ImageUtils.getImageBuffer(img);
                this.lazyParser = null;
                return this;
            }
        });
        return image2D;
    };
    ImageUtils.isImage2DValid = function (image2D) {
        if (image2D == null)
            return true;
        return this.isDimensionValid(image2D.width, image2D.powerOfTwo)
            && this.isDimensionValid(image2D.height, image2D.powerOfTwo);
    };
    ImageUtils.isHTMLImageElementValid = function (image) {
        if (image == null)
            return true;
        return this.isDimensionValid(image.width) && this.isDimensionValid(image.height);
    };
    ImageUtils.isDimensionValid = function (d, powerOfTwo) {
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        return d >= 1 && d <= this.MAX_SIZE && (!powerOfTwo || this.isPowerOfTwo(d));
    };
    ImageUtils.isPowerOfTwo = function (value) {
        return value ? ((value & -value) == value) : false;
    };
    ImageUtils.getBestPowerOf2 = function (value) {
        var p = 1;
        while (p < value)
            p <<= 1;
        if (p > this.MAX_SIZE)
            p = this.MAX_SIZE;
        return p;
    };
    ImageUtils.getDefaultImage2D = function () {
        if (!this._defaultBitmapImage2D)
            this.createDefaultImage2D();
        return this._defaultBitmapImage2D;
    };
    ImageUtils.getDefaultImageCube = function () {
        if (!this._defaultBitmapImageCube)
            this.createDefaultImageCube();
        return this._defaultBitmapImageCube;
    };
    ImageUtils.getDefaultSampler = function () {
        if (!this._defaultSampler)
            this.createDefaultSampler();
        return this._defaultSampler;
    };
    ImageUtils.createDefaultImageCube = function () {
        if (!this._defaultBitmapImage2D)
            this.createDefaultImage2D();
        var b = new BitmapImageCube(this._defaultBitmapImage2D.width);
        for (var i = 0; i < 6; i++) {
            b.drawBitmap(i, this._defaultBitmapImage2D.data, 0, 0, this._defaultBitmapImage2D.width, this._defaultBitmapImage2D.height);
        }
        this._defaultBitmapImageCube = b;
    };
    ImageUtils.createDefaultImage2D = function () {
        var b = new BitmapImage2D(8, 8, false, 0x000000);
        //create chekerboard
        var i, j;
        for (i = 0; i < 8; i++)
            for (j = 0; j < 8; j++)
                if ((j & 1) ^ (i & 1))
                    b.setPixel(i, j, 0XFFFFFF);
        this._defaultBitmapImage2D = b;
    };
    ImageUtils.createDefaultSampler = function () {
        this._defaultSampler = new ImageSampler();
    };
    ImageUtils.MAX_SIZE = 8192;
    return ImageUtils;
}());
export { ImageUtils };
export default ImageUtils;
